// extracted by mini-css-extract-plugin
export default {"container":"ClubRecord_container__m0Nx4"};